(function (){
    'use strict';

    angular
        .module('services')
        .service('CampaignsService', CampaignsService);

    //$httpParamSerializer

    CampaignsService.$inject = ['$http', 'API_BASE'];

    function CampaignsService ($http, API_BASE) {
        var service = this;
        service.getCampaigns            = getCampaigns;
        service.getAllCampaigns         = getAllCampaigns;
        service.get                     = get;
        service.saveCampaign            = saveCampaign;
        service.updateCampaign          = updateCampaign;
        service.getCampaigns            = getCampaigns;
        service.updateCampaignDate      = updateCampaignDate;
        service.deleteCampaign          = deleteCampaign;
        service.updateCampaignStatus    = updateCampaignStatus;
        service.getStatisticsUrl        = getStatisticsUrl;
        service.sendEmailTest           = sendEmailTest;
        service.getTswUrl               = getTswUrl;
        service.sendTokenLetter = sendTokenLetter;

        function getCampaigns (query) {
            return $http.get(API_BASE + '/email/campaign/list',{params:query});
        }

        function getAllCampaigns (query) {
            return $http.get(API_BASE + '/email/campaign/all',{params:query});
        }

        function get (query) {
            return $http.get(API_BASE + '/email/campaign/find/',{params:query});
        }

        function saveCampaign (query) {
            return $http.post(API_BASE + '/email/campaign/save',  JSON.stringify(query));
        }

        function updateCampaign (query) {
            return $http.post(API_BASE + '/email/campaign/update',  JSON.stringify(query));
        }

        function updateCampaignDate (query) {
            return $http.post(API_BASE + '/email/campaign/updateCampaignDate', query);
        }

        function deleteCampaign (query) {
            return $http.get(API_BASE + '/email/campaign/delete', {params:query});
        }

        function updateCampaignStatus (query) {
            return $http.get(API_BASE + '/email/campaign/updateStatus', {params:query});
        }

        function getStatisticsUrl (query) {
            return $http.get(API_BASE + '/email/campaign/getStatisticsUrl', {params:query});
        }

        function sendEmailTest (query) {
            return $http.get(API_BASE + '/email/campaign/sendEmailTest', {params:{
                    'id':query['id'],
                    'user_email':JSON.stringify(query['user_email'])
                }});
        }

        function getTswUrl () {
            return $http.get(API_BASE + '/email/campaign/get-url-tsw', {});
        }

        function sendTokenLetter(data) {
            return $http.post(API_BASE + "/email/campaign/letter-type/scheduling", data)
                .then(function (response) {
                    return response.data;
                });
        }
    }
})();